"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonMonospaceFonts = exports.fontSubsetCssAddress = exports.fontFamilyMap = exports.fontCssAddress = exports["default"] = void 0;
var _default = [{
  "fontCdn": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-fangsong-jianti.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-fangsong-jianti.svg",
  "fonts": [],
  "displayName": "方正仿宋_GBK",
  "fontFamily": "方正仿宋_GBK"
}, {
  "fontCdn": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-lishu.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-lishu.svg",
  "fonts": [],
  "displayName": "方正隶书_GBK",
  "fontFamily": "方正隶书_GBK"
}, {
  "fontCdn": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-xinkaiti.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-xinkaiti.svg",
  "fonts": [],
  "displayName": "方正新楷体_GBK",
  "fontFamily": "方正新楷体_GBK"
}, {
  "fontCdn": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-xinyaoti.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-xinyaoti.svg",
  "fonts": [],
  "displayName": "方正姚体_GBK",
  "fontFamily": "方正姚体_GBK"
}, {
  "isSecondLevel": true,
  "fontFamily": "腾讯体",
  "fontCdn": "",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/腾讯体.svg",
  "displayName": "腾讯体",
  "fonts": [{
    "fontFamily": "腾讯体 W3",
    "fontCdn": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans-w3.woff",
    "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans-w3.svg",
    "displayName": "腾讯体 W3"
  }, {
    "fontFamily": "腾讯体 W7",
    "fontCdn": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans-w7.woff",
    "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans-w7.svg",
    "displayName": "腾讯体 W7"
  }]
}, {
  "fontCdn": "https://docs.gtimg.com/common-cdn/ttf/HYZhongHeiTi-Level2.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/汉仪中黑.svg",
  "fonts": [],
  "displayName": "汉仪中黑",
  "fontFamily": "汉仪中黑"
}, {
  "fontCdn": "https://docs.gtimg.com/common-cdn/ttf/HYZhongHeiTi-Level3.ttf",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/汉仪中黑-补充字库.svg",
  "fonts": [],
  "displayName": "汉仪中黑-补充字库",
  "fontFamily": "汉仪中黑-补充字库"
}, {
  "fontCdn": "https://docs.gtimg.com/common-cdn/ttf/zaozigongfang-shaonv.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/造字工房芝士少女体.svg",
  "fonts": [],
  "displayName": "造字工房芝士少女体",
  "fontFamily": "造字工房芝士少女体"
}, {
  "fontCdn": "https://docs.gtimg.com/common-cdn/ttf/zaozigongfang-haiyan.woff",
  "fontSvg": "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/造字工房薄荷海盐体.svg",
  "fonts": [],
  "displayName": "造字工房薄荷海盐体",
  "fontFamily": "造字工房薄荷海盐体"
}];
exports["default"] = _default;
var fontFamilyMap = new Map([["方正仿宋_GBK", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-fangsong-jianti.woff"], ["方正新楷体_GBK", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-xinkaiti.woff"], ["方正姚体_GBK", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-xinyaoti.woff"], ["方正隶书_GBK", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fangzheng-lishu.woff"], ["腾讯体", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans.woff"], ["腾讯体 W3", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans-w3.woff"], ["腾讯体 W7", "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/tencent-sans-w7.woff"], ["汉仪中黑", "https://docs.gtimg.com/common-cdn/ttf/HYZhongHeiTi-Level2.woff"], ["汉仪中黑-补充字库", "https://docs.gtimg.com/common-cdn/ttf/HYZhongHeiTi-Level3.ttf"], ["造字工房芝士少女体", "https://docs.gtimg.com/common-cdn/ttf/zaozigongfang-shaonv.woff"], ["造字工房薄荷海盐体", "https://docs.gtimg.com/common-cdn/ttf/zaozigongfang-haiyan.woff"]]);
exports.fontFamilyMap = fontFamilyMap;
var nonMonospaceFonts = ["造字工房薄荷海盐体", "造字工房芝士少女体"];
exports.nonMonospaceFonts = nonMonospaceFonts;
var fontCssAddress = "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fonts.css";
exports.fontCssAddress = fontCssAddress;
var fontSubsetCssAddress = "https://alloyteam-cdn.cdn-go.cn/custom-fonts/1/fonts-subset.css";
exports.fontSubsetCssAddress = fontSubsetCssAddress;